import { IPatient, JobStatus, v2 } from '../../..';
import { personJobStatusAdapter, PersonJobStatusAdapterParts } from '.';
import { getHcpAttributeNames } from './helpers/getHcpAttributeNames';

type PersonJobParts = PersonJobStatusAdapterParts &
    Pick<
        IPatient,
        'hcpId' | 'hcpName' | 'hcpType' | 'hcpGrade' | 'buddyId' | 'buddyName' | 'buddyGrade'
    >;

export const personJobAdapter = (personJobs: v2.PersonJob[]): PersonJobParts => {
    let result: PersonJobParts = {};

    personJobs.forEach((personJob, index) => {
        const { person, personJobStatuses } = personJob;

        const isBuddy = index === 1;
        const { hcpId, hcpName } = getHcpAttributeNames(isBuddy);

        if (person?.id) {
            result[hcpId] = person.id;
        }

        const nameParts = [person?.firstName, person?.middleName, person?.lastName].filter(Boolean);

        if (nameParts.length > 0) {
            result[hcpName] = nameParts.join(' ');
        }

        const sortedPersonJobStatuses = (personJobStatuses || []).slice().reverse();

        const adaptedPersonJobStatuses = sortedPersonJobStatuses.map((personJobStatus, i) => {
            const isControllerReverse =
                sortedPersonJobStatuses[i - 1]?.jobTypeStatus?.key === JobStatus.CONTROLLER_ABORTED;
            const isHcpReverse =
                sortedPersonJobStatuses[i - 1]?.jobTypeStatus?.key === JobStatus.HCP_ABORTED;
            const previousStatus = sortedPersonJobStatuses[i - 1]?.jobTypeStatus?.key as JobStatus;
            const isLatestStatus = i === sortedPersonJobStatuses.length - 1;

            return personJobStatusAdapter(personJobStatus, {
                isBuddy,
                isControllerReverse,
                isHcpReverse,
                previousStatus,
                isLatestStatus,
            });
        });

        adaptedPersonJobStatuses.forEach((personJobStatus) => {
            result = {
                ...result,
                ...personJobStatus,
            };
        });
    });

    return result;
};
